// extracted by mini-css-extract-plugin
export default {"container":"components-settings-theme-selection-card-module__container","circle":"components-settings-theme-selection-card-module__circle"};